module.exports = __webpack_public_path__ + "static/img/qszy1024.6dfca096.png";